import { Component } from '@angular/core';

@Component({
  selector: 'zodi-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {}
